import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Define all vote links
const voteLinks = [
  'https://minecraft-mp.com/server/306253/vote/',
  'https://topminecraftservers.org/vote/28323',
  'https://minecraftpocket-servers.com/server/125287/vote/',
  'https://www.minecraftiplist.com/server/KaizenNetworkMinecraftServerIndonesia-37261/vote',
  'https://mcservertime.com/server-kaizen-network-server-indonesia.2636/vote',
  'https://minecraft-server-list.com/server/510684/vote/',
  'https://minecraft-serverlist.com/server/2429/vote',
  'https://top-mc-servers.net/server/434',
];

export function VoteRedirect() {
  const { index } = useParams<{ index: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!index) {
      navigate('/vote');
      return;
    }

    const voteIndex = parseInt(index, 10);
    
    if (isNaN(voteIndex) || voteIndex < 1 || voteIndex > voteLinks.length) {
      navigate('/vote');
      return;
    }

    // Get the vote link
    const voteLink = voteLinks[voteIndex - 1];
    
    // Log redirect for debugging
    console.log(`Redirecting to vote site #${voteIndex}: ${voteLink}`);
    
    // Immediate redirect
    window.location.href = voteLink;
  }, [index, navigate]);

  // Return nothing (empty component)
  return null;
} 